<div *ngIf="isHomeRoute" class="home-container">
  <h1>Welcome to CMP Platform</h1>
  <br />
  <br />
  <div class="card-grid">
    <div
      class="card"
      role="button"
      tabindex="0"
      (click)="navigateTo('/fe/capacities')"
      (keydown.enter)="navigateTo('/fe/capacities')"
      (keydown.space)="navigateTo('/fe/capacities'); $event.preventDefault()"
    >
      <h3>FE-Ipsoviz</h3>
      <p>
        FE-Ipsoviz centralizes capacity data across oil, gas, and water streams,
        with tools for managing facilities and planning capacities to improve
        visibility and operational decisions
      </p>
    </div>
    <div
      class="card"
      role="button"
      tabindex="0"
      (click)="navigateTo('/water-disposal/water-capacities-view')"
      (keydown.enter)="navigateTo('/water-disposal/water-capacities-view')"
      (keydown.space)="navigateTo('/water-disposal/water-capacities-view'); $event.preventDefault()"
    >
      <h3>Water Disposal</h3>
      <p>
        Manage and track water disposal across facilities for effective planning
      </p>
    </div>
    <div
      class="card"
      role="button"
      tabindex="0"
      (click)="navigateTo('/oil-gas-tab/gas-plant-capacities')"
      (keydown.enter)="navigateTo('/oil-gas-tab/gas-plant-capacities')"
      (keydown.space)="navigateTo('/oil-gas-tab/gas-plant-capacities'); $event.preventDefault()"
    >
      <h3>Oil & Gas Takeaway</h3>
      <p>
        Update and manage oil and gas facility capacities to ensure accurate
        tracking, efficient planning, and operational alignment
      </p>
    </div>
  </div>
</div>

<router-outlet></router-outlet>
